/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Text_PlaceholderInputs */

const en_import_text_placeholder = /** @type {(inputs: Import_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients and steps, in any order`)
};

const de_import_text_placeholder = /** @type {(inputs: Import_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten und Schritte, in beliebiger Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Ingredients and steps, in any order" |
*
* @param {Import_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_text_placeholder = /** @type {((inputs?: Import_Text_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Text_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_text_placeholder(inputs)
	return en_import_text_placeholder(inputs)
});